const ASSET_TYPES_TABLE_READY = "assetTypes-table-ready"
const SEARCH_TEXT_STATE = "assetTypes-table-search-text-state"
const ROWS_PER_PAGE_STATE = "assetTypes-table-rows-per-page-state"
const PAGINATION_STATE = "assetTypes-table-pagination-state"

const ASSET_TYPE_ID_FOR_ACTION = "assetTypes-table-assetType-id-for-action"

const ADD_EDIT_ASSET_TYPE_READY = "add-edit-assetType-ready"


const PREVIOUS_ASSET_TYPE_FILTER_STATUS = "previous-assetType-filter-status-action"

const PREVIOUS_ASSET_TYPE_FILTER_GROUP_ID = "previous-assetType-filter-group-id-action"



const initialState = {
    isAssetTypesTableReady: true,
    isAddEditAssetTypeReady:true,
    assetTypes: {},

    
    assetTypeSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterStatus : "",
    previousFilterGroupId : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ASSET_TYPES_TABLE_READY:
            return Object.assign({}, state, { isAssetTypesTableReady: action.payload })
        case ADD_EDIT_ASSET_TYPE_READY:
            return Object.assign({}, state, { isAddEditAssetTypeReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ASSET_TYPE_ID_FOR_ACTION:
            return Object.assign({}, state, {assetTypeSelectedId:action.payload})

        case PREVIOUS_ASSET_TYPE_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        case PREVIOUS_ASSET_TYPE_FILTER_GROUP_ID:
            return Object.assign({}, state, {previousFilterGroupId:action.payload})

        default:
        return state
    
    }

}

export function assetTypesTableReady(data) {
    return {
        type: ASSET_TYPES_TABLE_READY,
        payload: data
    }
}


export function addEditAssetTypeReady(data) {
    return {
        type: ADD_EDIT_ASSET_TYPE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function assetTypeIdForAction(assetTypeId){
    return{
        type:ASSET_TYPE_ID_FOR_ACTION,
        payload:assetTypeId
    }
}

export function previousFilterStatus(filterVal){
    return{
        type:PREVIOUS_ASSET_TYPE_FILTER_STATUS,
        payload:filterVal
    }
}


export function previousFilterGroupId(filterVal){
    return{
        type:PREVIOUS_ASSET_TYPE_FILTER_GROUP_ID,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Asset Types/redux/assetTypes.js